import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "header" };
var _hoisted_2 = { class: "main-content" };
import AppHeader from '@/components/app-header.vue';
import HomeChannel from '@/views/Home/components/home-channel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        // 使用setup语法糖后就无需注册了(这是vue2.7和vue3的特点)
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(AppHeader)
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(HomeChannel, { class: "channel" })
                ])
            ], 64));
        };
    }
});
